<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <BaseForm
      ref="form"
      :action="
        () => {
          return handleSubmit(submit);
        }
      "
      v-slot="formProps"
    >
      <div>
        <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">
          Deadline
          <span v-if="formProps.isResolved" key="resolved" class="text-green-600">Updated</span
          ><span v-if="formProps.isRejected" key="rejected" class="text-red-600">Failed</span>
        </h5>
        <div>
          <label class="select-none text-sm">
            <input
              id="hasTime"
              type="checkbox"
              v-model="formData.hasTime"
              :disabled="!editable || formProps.isPending"
              class="hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50"
              @change="
                $nextTick(() => {
                  $refs.dueAt.focus();
                })
              "
            />
            Include time
          </label>
          <input
            ref="dueAt"
            id="dueAt"
            :disabled="!editable || formProps.isPending"
            :type="formData.hasTime ? 'datetime-local' : 'date'"
            v-model="computedDueAt"
            class="px-4 py-2 leading-5 text-sm border rounded ml-2 hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50"
            @blur="onDueAtBlur"
            @keydown.enter="commitAttributesChanges(['dueAt', 'hasTime'])"
            @keydown.esc="revertAttributesChanges(['dueAt', 'hasTime'])"
          />
        </div>
      </div>
    </BaseForm>
  </ValidationObserver>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TaskDeadline',
  props: {
    editable: Boolean,
    task: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        dueAt: this.task.dueAt,
        hasTime: this.task.hasTime,
      },
    };
  },
  computed: {
    formattedDeadline() {
      if (!this.dueAt) return '';

      let dueAtFormat = 'YYYY-MM-DD';

      if (this.hasTime) {
        dueAtFormat = `${dueAtFormat} HH:mm`;
      }

      return moment(this.dueAt).format(dueAtFormat);
    },
    computedDueAt: {
      get() {
        let format = 'YYYY-MM-DD';

        if (this.formData.hasTime) {
          format = `${format}THH:mm`;
        }

        return moment(this.formData.dueAt).format(format);
      },
      set(value) {
        this.formData.dueAt = value;
      },
    },
  },
  watch: {
    'task.dueAt': {
      handler(newDueAt) {
        this.formData.dueAt = newDueAt;
      },
    },
    'task.hasTime': {
      handler(newHasTime) {
        this.formData.hasTime = newHasTime;
      },
    },
    'formData.dueAt': {
      handler() {
        this.$refs.form.handleSubmit();
      },
    },
    'formData.hasTime': {
      handler() {
        if (this.formData.dueAt) {
          this.$refs.form.handleSubmit();
        }
      },
    },
  },
  methods: {
    async submit() {
      try {
        await this.$store.dispatch({
          type: 'ui/tasks/update',
          taskUuid: this.task.uuid,
          formData: this.formData,
        });

        this.$emit('task:updated');
      } catch (error) {
        // should handle 244 errors
      }
    },
    onDueAtBlur() {
      setTimeout(() => {
        if (document.activeElement.id === 'hasTime') {
          document.getElementById('dueAt').focus();
        }
      }, 100);
    },
  },
};
</script>
